import React from "react"

class Votable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoved: false,
      currentLikes: +props.data.likes
    }
  }

  computeLike = () => {
    const { data, onLikeUpOrDown } = this.props
    if (this.state.currentLikes === data.likes ) {
      onLikeUpOrDown(1)
    }
    else {
      onLikeUpOrDown(-1)
    }
  }

  onLike = () => {
    const { currentLikes } = this.state
    const { data, hasLikes } = this.props
    if (hasLikes || currentLikes === +data.likes -1) {
      if (currentLikes < (+data.likes) + 1) {
        this.setState({
          currentLikes: currentLikes + 1
        }, () => {
          this.computeLike()
        })
      }
    }
  }

  onDislike = () => {
    const { currentLikes } = this.state
    const { data, hasLikes } = this.props
    if (hasLikes || currentLikes === +data.likes +1) {
      if (currentLikes > (+data.likes)  - 1) {
        this.setState({
          currentLikes: currentLikes - 1
        }, () => {
          this.computeLike()
        })
      }
    }
  }

  toggleIsLoved = () => {
    this.setState({
      isLoved: !this.state.isLoved
    })
  }
}

export default Votable
